<template>
	<div>
		<div class="slide">
			<el-carousel height="160px">
				<el-carousel-item v-for="(item,index) in data" :key="index">
					<a href="javascript:;" @click="url(item.url)">
						<img :src="item.image" class="item">
					</a>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div>
</template>

<script>
	import {
		common_slide
	} from '@/api/common.js';
	export default {
		name: 'commonSlide',
		data() {
			return {
				data: [],
			}
		},
		created() {
			this.get_data();
		},
		methods: {
			get_data() {
				common_slide({
					slide_id: 1
				}).then(res => {
					if (res.code == 1) {
						this.data = res.data;
					}
				});
			},

			url(path) {
				if (path.indexOf("http") != -1) {
					window.location.href = path;
				} else {
					this.$router.push(path);
				}
			}
		}
	}
</script>
<style scoped>
	.slide{
		width: calc(100% - 30x);
		padding:5px 15px;
		overflow: hidden;
	}
	.item {
		width: 100%;
	}

	/deep/ .el-carousel__arrow--left {
		left: 15px;
	}

	/deep/ .el-carousel__arrow--right {
		right: 15px;
	}

	/deep/ .el-carousel__button {
		background-color: #8a8a8a;
		width: 50px;
		height: 4px;
	}


</style>
